import { type TextProps } from '@loadsmart/miranda-react'

import { formatCurrency } from 'core/utils/currency'
import { formatToLocaleDate } from 'core/utils/date'

import { DocumentStatus, DocumentType, type POD } from '../domain/Document'
import { type Stop } from '../domain/Shipment'

export function formatDocumentDate(date: string | null | undefined): string {
  if (date) {
    return formatToLocaleDate(new Date(date), 'MMM d, yyyy, h:mm a') ?? ''
  }
  return ''
}

export function formatDocumentValue(value: string | number | undefined, type: DocumentType) {
  if (value && (type === DocumentType.Invoice || type === DocumentType.RateConfirmation)) {
    return formatCurrency(Number(value), true)
  }

  if (value) {
    return value
  }

  if (type === DocumentType.BOL) {
    return 'No number'
  }

  return '-'
}

export function getDocumentTitleProps(status?: DocumentStatus | null): Partial<{
  color: TextProps['color']
}> {
  if (status === DocumentStatus.Denied) {
    return { color: 'color-text-placeholder' }
  }

  return {}
}

export function formatDocumentSubtitle(document: POD, stops: Stop[], actionLabel: string): string {
  const formattedDate = formatDocumentDate(document.createdAt)

  if (document.stopIndex === undefined) {
    return formattedDate
  }

  const stop = stops.find(stop => stop.stopIndex === document.stopIndex)

  const locationName = stop
    ? stop.facility?.companyName ?? stop.facility?.warehouseName ?? stop.address ?? undefined
    : undefined

  const parts = [formattedDate, actionLabel].filter(Boolean)
  const result = parts.join(' ・ ')

  return locationName ? `${result}, ${locationName}` : result
}
